import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class AccordionItem extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.value', '');
  }

  get text() {
    return get(this, '_text.value', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }

  get smallText() {
    return get(this, '_small_text.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/AccordionItem.model.js